import React from 'react';
// import PropTypes from 'prop-types';

import splashImg from '../../../img/splash.png';

import styles from '../../../styles/partials/splash.module.scss';

const propTypes = {
    //
};

const defaultProps = {
    //
};

const SplashPartial = () => {
    return (
        <div className={styles.container}>
            <img className={styles.img} src={splashImg} alt="Splash" />
        </div>
    );
};

SplashPartial.propTypes = propTypes;
SplashPartial.defaultProps = defaultProps;

export default SplashPartial;
